import { useMemo, type CSSProperties } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { tokens } from '../theme/tokens';
import { buildNativeAppLink } from '../utils/nativeAppLink';
import { sanitizeReturnTo } from '../utils/returnTo';

export default function VerifyEmail() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const error = params.get('error');
  const returnTo = sanitizeReturnTo(params.get('returnTo'));
  const appLink = buildNativeAppLink('cittam://', returnTo);
  const failed = Boolean(error);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {failed ? (
          <XCircle size={56} color={tokens.semantic.error} style={styles.icon} />
        ) : (
          <CheckCircle size={56} color={tokens.semantic.success} style={styles.icon} />
        )}
        <h1 style={styles.title}>{failed ? 'Verification link expired' : 'Email verified'}</h1>
        <p style={styles.subtitle}>
          {failed
            ? 'Request a new verification link from CITTAM QR, then try again.'
            : 'Your email address is verified. You can now return to CITTAM QR.'}
        </p>
        <a href={appLink} style={styles.button}>
          Open CITTAM QR
        </a>
      </div>
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  container: {
    width: '100%',
    maxWidth: 420,
    margin: '0 auto',
  },
  card: {
    background: tokens.bg.card,
    backdropFilter: 'blur(12px)',
    borderRadius: tokens.radius.xl,
    padding: 32,
    border: `1px solid ${tokens.border.default}`,
    textAlign: 'center',
  },
  icon: {
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 8,
    color: tokens.text.primary,
  },
  subtitle: {
    fontSize: 14,
    color: tokens.text.muted,
    marginBottom: 28,
    lineHeight: 1.6,
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '14px 24px',
    fontSize: 16,
    fontWeight: 600,
    color: '#ffffff',
    background: `linear-gradient(135deg, ${tokens.brand.primary} 0%, ${tokens.brand.accent} 100%)`,
    border: 'none',
    borderRadius: tokens.radius.md,
    cursor: 'pointer',
    textDecoration: 'none',
  },
};
